import { cyan, grey, common, pink } from "@mui/material/colors";
import { alpha } from "@mui/material/styles";
// import { spacing } from "@mui/system";

const cyan500 = cyan[500];
const grey100 = grey[100];
const grey300 = grey[300];
const grey500 = grey[500];
const white = common.white;
const darkBlack = "#010203";
const fullBlack = "#000000";
const pinkA200 = pink[200];

// vars
const darkGray = "#1F1F21";
const darkGray2 = "#2C2D2F";
// const mediumGray = '#41454A';
// const transBlack = 'rgba(0,0,0,0.3)';
const textGray = "#828283";
// const white = '#ffffff';
// const transWhite = 'rgba(255, 255, 255, 0.3)';
// const transWhite2 = 'rgba(255, 255, 255, 0.5)';
// const link = '#29B6F6';
// const alert = '#E85858';

export default {
	// spacing: spacing,
	fontFamily: "Roboto, sans-serif",
	palette: {
		primary1Color: "#35b7f3",
		// primary2Color: darkGray2,
		// primary3Color: white,
		accent1Color: pinkA200,
		accent2Color: grey100,
		accent3Color: grey500,
		textColor: white,
		alternateTextColor: white,
		canvasColor: darkGray2,
		borderColor: grey300,
		disabledColor: "#828283",
		pickerHeaderColor: cyan500,
		clockCircleColor: alpha(darkBlack, 0.07),
		shadowColor: fullBlack,
		// New Material UI
		type: "dark",
		primary: {
			main: "#35b7f3"
		},
		background: { paper: darkGray2 }
	},

	components: {
		MuiAppBar: {
			height: 60
		},
		MuiDatePicker: {
			underlineShow: false
		},
		MuiTextField: {
			backgroundColor: darkGray,
			styleOverrides: {
				underlineShow: false,
				hintColor: textGray
			}
		},
		flatButton: {
			styleOverrides: {
				// fontSize: '.7em'
				fontWeight: "bold"
			}
		},
		MuiListItem: {
			styleOverrides: {
				secondaryTextColor: textGray
			}
		},
		MuiCheckbox: {
			styleOverrides: {
				root: { color: textGray },
				checked: { color: "#00bcd4" },
				disabled: {
					color: "#828283"
				},
				boxColor: textGray,
				requiredColor: darkGray,
				labelColor: "#9e9e9e",
				labelDisabledColor: "rgba(0,0,0,0.3)"
			}
		},
		toggle: {
			styleOverrides: {
				trackOnColor: "#2E7292",
				trackOffColor: "#969697",
				thumbOnColor: "#35B7F3",
				thumbOffColor: "#FFFFFF"
			}
		},
		MuiListSubheader: {
			color: white
		},
		// New Material UI and Material UI Pickers
		// TODO: Remove hard-coded styles from components

		MuiPickersToolbar: {
			styleOverrides: {
				toolbar: {
					backgroundColor: "#35b7f3"
				}
			}
		},
		MuiPickersDay: {
			styleOverrides: {
				selected: {
					backgroundColor: "#35b7f3"
				},
				current: {
					color: "#35b7f3"
				}
			}
		},
		MuiPickersModal: {
			styleOverrides: {
				dialogAction: {
					color: "#35b7f3"
				}
			}
		},
		MuiInput: {
			styleOverrides: {
				root: {
					color: "#fff"
				},
				underline: {
					"&:before": {
						borderBottom: "1px solid #828283"
					},
					"&:after": {
						borderBottom: "1px solid #35b7f3"
					},
					"&:hover:not($disabled):not($focused):not($error):before": {
						borderBottom: "1px solid #828283"
					}
				}
			}
		},
		MuiFormControlLabel: {
			styleOverrides: {
				root: { color: textGray, "&$focused": { color: textGray } },
				disabled: {
					color: "#7A7D81"
				}
			}
		},
		MuiSelect: {
			styleOverrides: {
				icon: {
					color: textGray
				},
				selectMenu: {
					"&:focus": { background: darkGray2 }
				}
			}
		},
		MuiIconButton: {
			styleOverrides: {
				root: { color: textGray }
			}
		},

		MuiFormHelperText: {
			styleOverrides: {
				root: { color: textGray }
			}
		},
		MuiTable: {
			styleOverrides: {
				root: { borderColor: textGray }
			}
		}
	}
};
